import { createUseQuery } from 'api/common/createUseQuery'
import { fetchGetBuilderProgress } from 'api/fetchers/digital-profile/fetchGetBuilderProgress'
import { ApiQueryKeys } from 'constants/apiQueryKeys'

export const useBuilderProgress = createUseQuery({
  queryKey: ApiQueryKeys.BUILDER_PROGRESS,
  fetcher: fetchGetBuilderProgress,
  selector: res => (res?.data as { progress: string | null; exists: boolean } | undefined) ?? (null as null),
})
